/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
// global elements
import Structure from 'components/shared/structure/structure_container';
// unique elements
import Frame from 'components/frames/frame_container';
import GiftCard from 'components/shared/reward/giftcard/giftcard_container';
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
import Close from 'components/shared/close/close';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/redeem/redeem_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ REDEEM SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class RedeemScreen extends Component {
    // createFrames() {
    //     return <Frame id={null} type={'redeem'} frameIndex={0} contentId={null} markup={this.createMarkup()} />;
    // }
    handleClose = (e) => {
        refreshAds();
        this.props.removeScreenWithPointsBarReset();
    }
    handleOpenTab = (e) => {
        e.preventDefault();
        refreshAds();
        window.open(url.b2cURL);
    }
    getBodyCopyText() {
        return `You have earned a ${this.props.monetaryValue} ${this.props.userGeo === 'US' ? 'Amazon ' : ''}gift card courtesy of Insticator.`;
    }
    createMarkup() {
        const giftCardName = this.props.userGeo === 'US' ? 'amazonstars' : 'genericstars';
        return (
            <div className={`redeem uniquescreen`}>
                <GiftCard type={giftCardName} />
                <Title>{`Thanks for your responses!`}</Title>
                <BodyCopy>
                    <p>{this.getBodyCopyText(this.props.rewardsData)}</p>
                </BodyCopy>
                <CTAs type={`inline`}>
                    <Button klass={`orange`} onClick={this.handleOpenTab}>{`Claim my card`}</Button>
                    <Button klass={`blue`} onClick={this.handleClose}>{`Save & Continue`}</Button>
                </CTAs>
            </div>
        );
    }
    render() {
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent inview-${this.props.inView}`}>
                {/*<Close handleClick={this.handleClose} />*/}
                <Structure contentId={this.props.contentId} markup={this.createMarkup()} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RedeemScreen;
